export const POLLINATOR_TEST_IDS = {
	NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
	HAMBURGER_MENU_BUTTON: 'rovo-chat-hamburger-menu-button',
} as const;
